<template>
  <v-content>
      <v-card v-if="graphdata">
          <v-toolbar color="secondary" dark>
              <v-toolbar-title :style="$store.state.textFormatting.headers">
                  System Statistics over the last 7 days
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-tooltip top color="secondary">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="refreshData" fab small icon><v-icon :style="$store.state.textFormatting.main"> refresh </v-icon></v-btn>
                    </template>
                    <span :style="$store.state.textFormatting.main">Refresh</span>
              </v-tooltip>
              <v-toolbar-title>
                  <small>
                    <small :style="$store.state.textFormatting.main">
                        {{ updatedStr }}
                    </small>
                  </small>
              </v-toolbar-title>
          </v-toolbar>
          
          
          <br />
          <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 md3 v-for="(i, key) in graphdata[0]" :key="key" class="py-2 px-2">
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title :style="$store.state.textFormatting.headers">
                            {{DataTypeName[key]}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <info>
                            <template>
                                {{DataTypeName[key]}}
                            </template>
                            <template slot="body">
                                {{DataTypeBodyInfo[key]}}
                            </template>
                        </info>
                    </v-toolbar>
                    <v-card>
                        <v-card-text>
                            <bar-chart dark :chart-data="i[0]" :options="options"></bar-chart>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
          </v-card-text>
      </v-card>
  </v-content>
</template>

<script>

import dbgraph from '../../shared/operational/event-to-episode-graph.vue'
import linegraph from '../../shared/developing/line-graph.vue'
import BarChart from '../operational/BarChart.js'
import info from '../operational/infopopout.vue'
import { findParentComponentByName } from '../../components/utils/findParent.js'

export default {
    components: {
        BarChart,
        info
    },
    data () {
        return {
            graphdata: [{
                "total_episode_count": [],
                "total_event_count": [],
                "hijack_count": [],
                "unique_prefix_count": [],
                "bogon_count": [],
                "route_leak_count": [],
                "path_change_count": [],
                "first_obs_count": [],
                "interval_start": [],
            }],
            DataTypeName: {"total_episode_count": "Total Episode Count",
                "total_event_count": "Total Event Count",
                "hijack_count": "Ownership Change Count ",
                "unique_prefix_count":"Unique Prefix Count",
                "bogon_count": "Bogon Count",
                "route_leak_count": "Route Leak Count",
                "path_change_count": "Path Change Count",
                "first_obs_count": "First Observation Count"},
            DataTypeBodyInfo: {
                "total_episode_count": "Number of episodes seen in each time window.",
                "total_event_count": "Number of events seen in each time window.",
                "hijack_count": "Number of ownership change events in the time window (excluding super-ownership assertions) -see Glossary of terms.",
                "unique_prefix_count":"Number of unique prefixes seen in each time window.",
                "bogon_count": "Number of bogons seen in each time window - see Glossary of terms",
                "route_leak_count": "Number of route leaks seen in each time window - see Glossary of terms.",
                "path_change_count": "Number of path change events seen in each time window - see Glossary of terms.",
                "first_obs_count": "Number of first observation events seen in each time window - see Glossary of terms."
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    titleFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10, 
                    bodyFontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                },
                title: {
                    display: true,
                    fontSize: 16
                },
                legend: {
                    display: false,
                    position: 'top',
                    labels: {
                        fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                    },
                },
                scales: {
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Count',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            min: 0,
                            fontSize: this.$store.state.textFormatting.chart.axis_label
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Time',
                            fontSize: this.$store.state.textFormatting.traceroute.fontSize + 10
                        },
                        ticks: {
                            display: false
                        }
                    }]
                }
                },
                updatedStr: "",

        }
    },
    beforeMount () {
        this.createGraphData()
        
    },
    mounted () {
        this.updatedStr = this.$store.state.systemStatsUpdate;
    },
    methods: {
        refreshData: async function () {
            this.graphdata = [{
                "total_episode_count": [],
                "total_event_count": [],
                "hijack_count": [],
                "unique_prefix_count": [],
                "bogon_count": [],
                "route_leak_count": [],
                "path_change_count": [],
                "first_obs_count": [],
                "interval_start": [],
            }]
            let app = findParentComponentByName(this, 'app')
            await app.systemStatsDashboardDownload()
            this.updatedStr = this.$store.state.systemStatsUpdate;
            this.createGraphData()
            
        },
        createGraphData: function () {
            var data = this.$store.state.systemStats
//            console.log(data)
            var allDataKeys = Object.keys(data[0])
            for(var n=0; n< allDataKeys.length; n=n+1) {
                try {
                    if (allDataKeys[n] != 'interval_start') {
                        var justoneparam = [];
                        for (var i=0; i< data.length; i=i+1) {
                            justoneparam.push({Time: data[i][allDataKeys[n]], interval_start: data[i]["interval_start"]})
                        }
                    }
                    var formattedData = this.formatTheDataInToTables(justoneparam)
                    this.graphdata[0][allDataKeys[n]].push(formattedData)
                } catch (err) {
                    console.log(err)
                }
            }
        },
        formatTheDataInToTables: function (oneParamType) {
            var datakeys = Object.keys(oneParamType[0])
            var graphdata = { labels: [datakeys[0]], datasets: [] }
            for (var i =0; i< oneParamType.length; i = i+1){
                    var date = new Date(oneParamType[i].interval_start * 1000)
                    var datelabel = date.getUTCDate() + "/" + (date.getUTCMonth() +1) + "/" + date.getUTCFullYear() + date.toGMTString().substr(16, 9) + " + 1 Day"
              
                    var dataset =   {label: [datelabel], data: [oneParamType[i][datakeys[0]]],
                                    fill: false, borderColor: '#6400aa', backgroundColor: '#6400aa',
                                    pointHitRadius: '2', pointBorderWidth: '5'}
                    graphdata.datasets.push(dataset)
            }

            return graphdata

        }
    }

}
</script>

<style>



</style>